/* istanbul ignore file */

import React, { useState, useCallback } from 'react';
import { ConfirmDialog } from '@bingads-webui-campaign-react/confirm-dialog';

const useImageDelete = (props) => {
  const {
    i18n,
    imageRepository,
    userPhotoDataSource,
    imageList,
    isAudienceAd,
  } = props;

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [isUiBlocked, setIsUiBlocked] = useState(false);
  const [deleteImageIdString, setDeleteImageIdString] = useState();
  const [imageDeleteErrorMessage, setImageDeleteErrorMessage] = useState('');

  const onDeleteImageConfirmed = useCallback(() => {
    setIsUiBlocked(true);

    return imageRepository.deleteImageAsync({
      IdString: deleteImageIdString,
    }).then(() => {
      userPhotoDataSource.reload();
      setShowDeleteConfirm(false);
    }).catch((response) => {
      setImageDeleteErrorMessage(response.errors.map(error => i18n.getString(`Error_ImageValidation_${error.Code}`))[0]);
    }).finally(() => {
      setIsUiBlocked(false);
    });
  }, [deleteImageIdString, i18n, imageRepository, userPhotoDataSource]);

  const onUserImageDelete = useCallback((imageIdString) => {
    setImageDeleteErrorMessage('');
    setShowDeleteConfirm(true);
    setDeleteImageIdString(imageIdString);

    const imageIdsUsed = [];

    if (Array.isArray(imageList)) {
      imageList.forEach((imageListItem) => {
        if (Array.isArray(imageListItem)) {
          imageListItem.forEach((imageListItemItem) => {
            imageIdsUsed.push(imageListItemItem.idString);
          });
        } else {
          imageIdsUsed.push(imageListItem.idString);
        }
      });
    }

    if (imageIdsUsed.indexOf(imageIdString) >= 0) {
      if (isAudienceAd) {
        setImageDeleteErrorMessage(i18n.getString('ImageExperience_Media_Delete_Error_UseInDraft'));
      } else {
        setImageDeleteErrorMessage(i18n.getString('ImageExperience_Multimedia_Delete_Error_UseInDraft'));
      }
    }
  }, [imageList, i18n, isAudienceAd]);

  const ImageDeleteConfirm = () => (
    <ConfirmDialog
      isDisplayed={showDeleteConfirm}
      title={i18n.getString('ImageExperience_Image_Delete_Confirm')}
      errorText={imageDeleteErrorMessage}
      confirmString={i18n.getString('ImageExperience_Confirm')}
      cancelString={i18n.getString('ImageExperience_Cancel')}
      onClickConfirm={() => { onDeleteImageConfirmed(); }}
      onClickCancel={() => { setShowDeleteConfirm(false); }}
      isUiBlocked={isUiBlocked}
    />
  );


  return { ImageDeleteConfirm, onUserImageDelete };
};

export { useImageDelete };
